import React from 'react';
import PropTypes from 'prop-types';
import { HeaderWrapper } from './styles';
import TableCell from '../TableCell';


const TableHeader = ({
  colums, dictionary, isSortable, actions, isMobile,
}) => (
  <HeaderWrapper isSortable={isSortable} className="generalBackground">
    {colums && colums.map((col, index) => (
      <TableCell
        label={col.label.bind(dictionary, col.colName)()}
        labelTooltip={col.label.bind(dictionary.toolTip, col.colName)()}
        width={col.width}
        weight="bold"
        alignment={col.alignment}
        position={col.position}
        left={col.left}
        top={col.top}
        caps={col.caps}
        isSortable={isSortable}
        overrideMargin={col.overrideMargin}
        overridePadding={col.overridePadding}
        key={index}
        actions={actions}
        colName={col.colName}
        isToolTip={!col.hideTooltip}
        specialTooltip={col.specialTooltip}
        isMobile={isMobile}
      />

    ))}
  </HeaderWrapper>
);

TableHeader.propTypes = {
  colums: PropTypes.any,
  actions: PropTypes.any,
  dictionary: PropTypes.any,
  isSortable: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default TableHeader;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableHeader/index.js